<div class="auth-wrapper auth-v2">
  <app-language-selector></app-language-selector>
    <div class="auth-inner max-width row m-0">
        <div class="d-flex align-items-center p-5 l-side">
            <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                <img
                        class="img-fluid"
                        [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/forgot-password-v2-dark.svg'
              : 'assets/images/forgot-password.svg'
          "
                        alt="Forgot password V2"
                />
            </div>
        </div>
        <!-- /Left Text-->
        <!-- Forgot password-->
        <div class="d-flex align-items-center auth-bg r-side">
            <div class="mx-auto login-form">
                <h2 class="c-company">{{'RESET_PASSWORD.FORM_HEADER' | translate}}</h2>
<!--                <p class="card-text mb-2">{{'RESET_PASSWORD.FORM_HEADER' | translate}}</p>-->
                <form class="auth-forgot-password-form mt-2" [formGroup]="resetPasswordForm">
                    <div class="form-group">
                        <label for="reset-password"
                               class="form-label">{{'RESET_PASSWORD.PASSWORD_LABEL' | translate}}</label>

                        <div class="input-group input-group-merge form-password-toggle">
                            <input
                                    [type]="passwordTextType ? 'text' : 'password'"
                                    formControlName="password"
                                    id="reset-password"
                                    class="form-control form-control-merge"
                                    placeholder="············"
                                    aria-describedby="reset-password"
                                    tabindex="3"
                                    [ngClass]="{ 'is-invalid error':  (f.password.dirty || f.password.touched) && f.password.errors }"
                            />
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer" (click)="togglePasswordTextType()">
                                  <i *ngIf="passwordTextType" class="feather icon-eye-off"></i>
                                  <i *ngIf="!passwordTextType" class="feather icon-eye"></i>                
                                </span>
                              </div>

                        </div>
                        <div
                                *ngIf="(f.password.dirty || f.password.touched) &&  f.password.errors"
                                class="invalid-feedback"
                                [ngClass]="{ 'd-block': (f.password.dirty || f.password.touched) && f.password.errors }"
                        >
<!--                            <div *ngIf="f.password.errors.required">{{'RESET_PASSWORD.PASSWORD_REQUIRED' | translate}}</div>-->
                            <div *ngIf="f.password.errors.missMatch">{{'RESET_PASSWORD.PASSWORD_MISSMATCH' | translate}}</div>
                        </div>
                        <ng-container *ngIf="(f.password.dirty || f.password.touched) &&  f.password.errors">
                            <span class="p-required r1" *ngIf="f.password.errors.requiredLength"><i
                                    class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_LENGTH' | translate}}</span>
                            <span class="p-required r2" *ngIf="f.password.errors.hasUpperCase"><i
                                    class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_UPPERCASE' | translate}}</span>
                            <span class="p-required r3" *ngIf="f.password.errors.hasLowerCase"><i
                                    class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_LOWERCASE' | translate}}</span>
                            <span class="p-required r4" *ngIf="f.password.errors.hasNumeric"><i
                                    class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_NUMERIC' | translate}}</span>
                            <span class="p-required r5" *ngIf="f.password.errors.hasSpecialChar"><i
                                    class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_SPECIAL_CHAR' | translate}}</span>
                            <span class="p-required r6" *ngIf="f.password.errors.notEmail"><i
                                    class="fa fa-check-circle-o"></i>{{'RESET_PASSWORD.PASSWORD_MATCH_EMAIL' | translate}}</span>
                        </ng-container>
                    </div>

                    <div class="form-group">
                        <label for="reset-repeat-password"
                               class="form-label">{{'RESET_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate}}</label>

                        <div class="input-group input-group-merge form-password-toggle">
                            <input
                                    [type]="passwordTextType ? 'text' : 'password'"
                                    formControlName="confirmPassword"
                                    id="reset-repeat-password"
                                    class="form-control form-control-merge"
                                    placeholder="············"
                                    aria-describedby="reset-repeat-password"
                                    tabindex="3"
                                    [ngClass]="{ 'is-invalid error': (f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors }"
                            />
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer" (click)="togglePasswordTextType()">
                                  <i *ngIf="passwordTextType" class="feather icon-eye-off"></i>
                                  <i *ngIf="!passwordTextType" class="feather icon-eye"></i>                
                                </span>
                              </div>

                        </div>
                        <div
                                *ngIf="(f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors"
                                class="invalid-feedback"
                                [ngClass]="{ 'd-block': (f.confirmPassword.dirty || f.confirmPassword.touched) && f.confirmPassword.errors }"
                        >
                            <div *ngIf="f.confirmPassword.errors.required">{{'RESET_PASSWORD.CONFIRM_PASSWORD_REQUIRED' | translate}}</div>
                            <div *ngIf="f.confirmPassword.errors.missMatch">{{'RESET_PASSWORD.CONFIRM_PASSWORD_MISSMATCH' | translate}}</div>
                        </div>
                    </div>
                    <button class="btn btn-primary btn-block" tabindex="2" rippleEffect (click)="resetPassword()"
                            [disabled]="resetPasswordForm.invalid">
                        <i class="fa fa-arrow-right"></i>{{'RESET_PASSWORD.RESET_PASSWORD' | translate}}
                    </button>
                </form>
                <p class="text-center mt-2">
                    <a routerLink="/pages/authentication/login" class="c-company"><i
                            data-feather="chevron-left"></i>{{'RESET_PASSWORD.BACK_TO_LOGIN' | translate}}</a>
                </p>
            </div>
        </div>
        <!-- /Forgot password-->
    </div>
</div>
